export const accountOwnerCollection = [
  { id: '1', name: 'Sukhov, Yevhenii', email: 'ysukhov@jetsmarter.com' },
  { id: '2', name: 'User, Test', email: 'test_user@test.com' },
  { id: '3', name: 'Rivera, Genderie', email: 'GRivera@Jetsmarter.com' },
  { id: '4', name: 'Karasiewicz, Jacob', email: 'JKarasiewicz@Jetsmarter.com' },
  { id: '5', name: 'Ali, Jordan', email: 'JAli@Jetsmarter.com' },
  { id: '6', name: 'Hitchings, Greg', email: 'GHitchings@Jetsmarter.com' },
  { id: '7', name: 'Wilkie, Daniel', email: 'DWilkie@Jetsmarter.com' },
  { id: '8', name: 'Karpinski, Anthony', email: 'AKarpinski@Jetsmarter.com' },
  { id: '9', name: 'Sutliffe, Nathaniel', email: 'NSutliffe@Jetsmarter.com' },
  { id: '10', name: 'Yakovenko, Nickolay', email: 'NYakovenko@Jetsmarter.com' },
];
